const szukaj = { t: 'Szukaj', name: 'fraza' }
export default szukaj